;(function () {
	const globalKey = '__sofaDreamsImageWithTextVideo'

	if (window[globalKey]) {
		window[globalKey].init()
		return
	}

	const initializedSections = new Set()

	const safePlay = (video) => {
		if (!video || !video.paused) return Promise.resolve()

		try {
			const playPromise = video.play()

			if (playPromise && typeof playPromise.catch === 'function') {
				return playPromise.catch((error) => {
					if (
						error &&
						(error.name === 'AbortError' || error.name === 'NotAllowedError')
					) {
						return
					}

					console.warn('Image-with-text video could not be played.', error)
				})
			}
		} catch (error) {
			console.warn('Image-with-text video could not be played.', error)
		}

		return Promise.resolve()
	}

	const stopVideo = (section) => {
		section.querySelectorAll('video').forEach((video) => {
			if (!video.paused) video.pause()
		})

		section.querySelectorAll('.js-play-video-img-text').forEach((button) => {
			button.classList.remove('active')
		})
	}

	const playVideo = (section) => {
		section
			.querySelectorAll('.image-with-text__video.autoplay video')
			.forEach((video) => {
				// Muted playback is required for reliable autoplay in modern browsers.
				video.muted = true
				safePlay(video)

				const button = video.parentElement?.querySelector(
					'.js-play-video-img-text'
				)

				if (button) button.classList.remove('active')
			})
	}

	const controlsVideo = (section) => {
		section.querySelectorAll('.js-play-video-img-text').forEach((button) => {
			button.addEventListener('click', () => {
				const video = button.parentElement?.querySelector('video')
				if (!video) return

				if (video.paused) {
					safePlay(video).then(() => {
						if (!video.paused) button.classList.toggle('active')
					})
				} else {
					video.pause()
					button.classList.toggle('active')
				}
			})
		})

		section.querySelectorAll('.js-sound-video-img-text').forEach((button) => {
			button.addEventListener('click', () => {
				const video = button.parentElement?.querySelector('video')
				if (!video) return

				video.muted = !video.muted
				button.classList.toggle('active')
			})
		})
	}

	const sectionObserver =
		'IntersectionObserver' in window
			? new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							entry.target.dataset.imageWithTextVisible = entry.isIntersecting
								? 'true'
								: 'false'

							if (entry.isIntersecting) playVideo(entry.target)
							else stopVideo(entry.target)
						})
					},
					{ threshold: 0.01 }
			  )
			: null

	const getSections = (root = document) => {
		const sections = []

		if (root instanceof Element && root.matches('.image-with-text-section')) {
			sections.push(root)
		}

		if (typeof root.querySelectorAll === 'function') {
			sections.push(...root.querySelectorAll('.image-with-text-section'))
		}

		return sections
	}

	const init = (root = document) => {
		getSections(root).forEach((section) => {
			if (initializedSections.has(section)) return

			initializedSections.add(section)
			controlsVideo(section)

			if (sectionObserver) sectionObserver.observe(section)
			else playVideo(section)
		})
	}

	const unload = (root) => {
		getSections(root).forEach((section) => {
			if (sectionObserver) sectionObserver.unobserve(section)
			initializedSections.delete(section)
		})
	}

	window[globalKey] = { init, unload }

	init()

	document.addEventListener('shopify:section:load', (event) => {
		init(event.target)
	})

	document.addEventListener('shopify:section:unload', (event) => {
		unload(event.target)
	})
})()
